module.exports = __webpack_public_path__ + "img/2024big14.d6f5c145.png";